<template>
  <div class="p-20px">
    <div class="mb-20px">
      <div class="flex items-center justify-between">
        <div class="w-35px h-35px" @click="goBack">
          <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full">
        </div>
        <div class="color-#fff text-14px">
          Settings
        </div>
        <div class="w-35px h-35px">

        </div>
      </div>
    </div>
    <!-- 设置列表 -->
    <div class="settings-list">
      <div class="setting-item" @click="goEditProfile">
        <div class="left relative">
          <img src="@/assets/images/mine/edit_profile.svg" alt="" class="w-20px mr-12px">
          <span class="text">Edit Profile</span>
          <span class="dot" v-if="!isEditInfo"></span>
        </div>
      </div>
      <!-- <div class="setting-item">
        <div class="left">
          <img src="@/assets/images/setting/notification.svg" alt="" class="w-20px mr-12px">
          <span class="text">System Notification</span>
        </div>
        <div class="w-28px h-12px flex item-centers ml-auto" @click="handleNotification">
          <img v-if="!isNotification" src="@/assets/images/setting/kai.svg" class="w-full h-full"></img>
        </div>
      </div> -->
      <div class="setting-item" @click="goFAQ">
        <div class="left">
          <img src="@/assets/images/mine/fqa.svg" alt="" class="w-20px mr-12px">
          <span class="text">FAQ</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>


      <div class="setting-item" @click="openTerms">
        <div class="left">
          <img src="@/assets/images/mine/use.svg" alt="" class="w-20px mr-12px">
          <span class="text">Terms of use</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>

      <div class="setting-item" @click="openPrivacy">
        <div class="left">
          <img src="@/assets/images/mine/privacy_olicy.svg" alt="" class="w-20px mr-12px">
          <span class="text">Privacy Policy</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <div class="setting-item" @click="handleAboutAccount">
        <div class="left">
          <img src="@/assets/images/home/account.webp" alt="" class="w-20px mr-12px">
          <span class="text">About account</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
      <div class="setting-item" @click="clearCache">
        <div class="left">
          <img src="@/assets/images/mine/clean.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">Clear cache</span>
        </div>
      </div>
      <div class="setting-item" @click="deleteAccount">
        <div class="left">
          <img src="@/assets/images/mine/delete.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">Delete Account</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>

      <div class="setting-item" @click="handleLogout">
        <div class="left">
          <img src="@/assets/images/mine/out.svg" alt="" class="w-20px mr-12px"></img>
          <span class="text">Log Out</span>
        </div>
        <!-- <span class="arrow">›</span> -->
      </div>
    </div>
    <div class="color-#fff flex items-center justify-center fixed bottom-30px left-0 right-0">
      <div class="w-25px h-20px flex items-center justify-center">
        <img src="@/assets/images/home/version.webp" alt="" class="w-full h-full mr-12px">
      </div>
      <div class="text-version">
        Version {{ version }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useDialog } from '@/composables/useDialog'
import { useLoginDialog } from '@/composables/useLoginDialog'
import { showLoadingToast, showToast, closeToast } from '@/utils/toast'
import theme from '@/styles/theme'
import bridge from '@/utils/bridge'
import { version } from '../../../package.json'
import { logEventSafe } from '@/plugins/firebase'
const router = useRouter()
const userStore = useUserStore()
const dialog = useDialog()
const $loginDialog = useLoginDialog()
const isEditInfo = computed(() => userStore.getIsEditInfo())
const goEditProfile = () => {
  router.push({ name: 'EditProfile' })
}
// 这些变量将在clearCache函数中使用
const handleLogout = async () => {

  const confirmed = await dialog.confirm({
    title: 'Log Out',
    message: 'After logging out, you will need to log in again to use your account again. Are you sure to log out?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    bridge.callApp('appClose')
    // 先清除用户数据
    userStore.logOut()

    // 立即跳转到登录页面，避免路由守卫的检查循环
    $loginDialog.show()
  }
}
const goBack = () => {
  router.back()
}
const goFAQ = () => {
  router.push({ name: 'FAQ' })
}
const openTerms = () => {
  router.push({ name: 'Terms' })
}
const openPrivacy = () => {
  router.push({ name: 'Policy' })
}
const handleAboutAccount = () => {
  router.push({ name: 'Account' })
}
const deleteAccount = async () => {
  try {
    const confirmed = await dialog.confirm({
      title: 'Delete Account',
      message: 'Deleting your account will erase all your data and information and cannot be undone. Confirm deletion?',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#667eea'
    })

    if (confirmed) {
      try {
        showLoadingToast('Deleting account...')
        await userStore.deleteUser()
        showToast('Account deleted successfully', { type: 'success' })
        localStorage.removeItem('isNewUserLogin')
        localStorage.removeItem('first_pay_success_to_vippage')

        bridge.callApp('appClose')

        $loginDialog.show()
        // router.replace({ name: 'Login' })
      } catch (error) {
        console.log('User cancelled, error:', error)
      } finally {
        closeToast()
      }
    }
  } catch (error) {
    // 用户点击了取消或关闭
    console.log('User cancelled, error:', error)
  }
}
const clearCache = async () => {
  const confirmed = await dialog.confirm({
    title: 'Cache cleaning',
    message: 'Clearing app cache, chat history and chat roles will not deleted',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    logEventSafe('user_cache_cleaning')
    showLoadingToast('Cleaning')
    // 🔧 备份重要数据（在清除缓存前备份）
    const token = userStore.getStoredToken()
    const appId = userStore.getAppId()
    const udid = userStore.getudid()

    // 调用app清除缓存
    bridge.callApp('appClearTheCache')

    // 🔧 修复：跳转后立即显示toast
    setTimeout(() => {
      // 恢复重要数据
      if (token) userStore.setToken(token)
      if (appId) userStore.setAppId(appId)
      if (udid) userStore.setudid(udid)
      localStorage.setItem('isNewUserLogin', '1')
      // 先跳转到首页
      router.push({
        path: '/'
      })

      // 🔧 在跳转后立即显示成功提示（通过延时确保页面加载完成）
      setTimeout(() => {
        showToast('Cleaning completed', { type: 'success', duration: 2000 })
      }, 100)
    }, 500)
  }
}
</script>

<style scoped>
.settings-list {
  margin-top: 12px;

  .setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 14px;
    border-radius: 12px;
    background: v-bind('theme.colors.backgroundSecondary');
    color: #fff;
    margin-bottom: 10px;

    .left {
      display: flex;
      align-items: center;

      .icon {
        margin-right: 10px;
        width: 20px;
        text-align: center;
      }

      .text {
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
      }

      .dot {
        position: absolute;
        top: 0px;
        right: -6px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ff4d8d;
      }
    }

    .arrow {
      color: v-bind('theme.colors.textPrimary');
      font-size: 18px;
    }
  }
}

.text-version {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}
</style>